import { v4 as uuid } from 'uuid';

export const getInitialSimulatorState = () => ({
    name: '',
    file: null,
    fileName: '',
    sections: [
        {
            id: uuid(),
            name: '',
            topics: [
                {
                    id: uuid(),
                    name: '',
                    fields: [
                        {
                            id: uuid(),
                            title: '',
                            cell: '',
                            unit_of_measurement: '',
                            position: 'left',
                            format: 'text',
                            decimal_places: 0,
                            list_items: []
                        }
                    ]
                }
            ]
        }
    ],
    boxes: [],
    validationErrors: {}
});

const simulatorReducer = (state = getInitialSimulatorState(), action) => {
    switch (action.type) {
        case 'SIMULATOR_SET_NAME':
            return { ...state, name: action.payload };
        case 'SIMULATOR_SET_FILE':
            return { ...state, file: action.payload };
        case 'SIMULATOR_SET_FILE_NAME':
            return { ...state, fileName: action.payload };
        case 'SIMULATOR_SET_SECTIONS':
            return { ...state, sections: action.payload };
        case 'SIMULATOR_SET_BOXES':
            return { ...state, boxes: action.payload };
        case 'SIMULATOR_SET_VALIDATION_ERRORS':
            return { ...state, validationErrors: action.payload };
        case 'SIMULATOR_CLEAR_VALIDATION_ERRORS':
            return { ...state, validationErrors: {} };
        case 'SIMULATOR_SET_FIELD_ERROR':
            return {
                ...state,
                validationErrors: {
                    ...state.validationErrors,
                    [action.payload.fieldPath]: action.payload.errorMessage
                }
            };
        case 'SIMULATOR_RESET':
            return getInitialSimulatorState();
        default:
            return state;
    }
};

export default simulatorReducer;
